// extracted by mini-css-extract-plugin
export default {"heading":"Ev-z","corrected":"Fv-z","redirectVerbiageContainer":"Gv-z","redirectVerbiageText":"Hv-z"};